
// Internet Explorer 6-11
const isIE = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.indexOf('edge') > 0 || ua.indexOf('ie') > 0
}

export {
  isIE
}
